<template>
    <div class="experts_section" id="experts-logistique">
        <h2>{{ $t('experts.title') }}</h2>
        <div class="logo-scroll-container">
            <div class="logo-scroll" ref="scrollContent">
                <div v-for="logo in [...logos, ...logos]" :key="logo.id" class="logo-item" :class="{'logo_cp' : logo.id === 1 || logo.id === 7}">
                    <img :src="logo.src" :alt="logo.alt" loading="lazy">
                </div>
            </div>
            <div class="logo-scroll reverse" ref="scrollContentReverse">
                <div v-for="logoReverse in [...logos, ...logos]" :key="logoReverse.id" class="logo-item"  :class="{'logo_cp' : logoReverse.id === 1 || logoReverse.id === 7}" >
                    <img :src="logoReverse.src" :alt="logoReverse.alt" loading="lazy">
                </div>
            </div>
        </div>
    </div>
</template>
 
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import logo1 from '../assets/experts/commandes-expert-logistique.webp';
import logo2 from '../assets/experts/equipe-logistique-GMA.webp';
import logo3 from '../assets/experts/responsable-logistique.webp';
import logo4 from '../assets/experts/specialiste-supply-chain.webp';
import logo5 from '../assets/experts/superviseur-entrepot.webp';
import logo6 from '../assets/experts/technicien-stockage.webp';
import logo7 from '../assets/experts/marchandises-expert-logistique.webp'

 
const logos = ref([
    { id: 1, src: logo1, alt: 'Logo du partenaire GMA Collection Platinium' },
    { id: 2, src: logo2, alt: "Logo du partenaire GMA Vel'Air" },
    { id: 3, src: logo3, alt: 'Logo du partenaire GMA Soleil Sucré' },
    { id: 4, src: logo4, alt: 'Logo du partenaire GMA Ora Bora' },
    { id: 5, src: logo5, alt: 'Logo du partenaire GMA Noely' },
    { id: 6, src: logo6, alt: 'Logo du partenaire GMA Potiron Paris' },
    { id: 7, src: logo7, alt: 'Logo du partenaire GMA Little Marcel' },
]);
 
// const logosReverse = ref([
//     { id: 1, src: logo1, alt: 'Logo 1' },
//     { id: 2, src: logo2, alt: 'Logo 2' },
//     { id: 3, src: logo1, alt: 'Logo 1' },
//     { id: 4, src: logo2, alt: 'Logo 2' },
//     { id: 5, src: logo1, alt: 'Logo 1' },
//     { id: 6, src: logo2, alt: 'Logo 2' },
//     { id: 7, src: logo1, alt: 'Logo 1' },
//     { id: 8, src: logo2, alt: 'Logo 2' },
// ]);

let animationId = null;
const scrollContent = ref(null);
const scrollContentReverse = ref(null);

onMounted(() => {
  const scrollContent = document.querySelector('.logo-scroll');
  const scrollContentReverse = document.querySelector('.logo-scroll.reverse');
 
  if (scrollContent && scrollContentReverse) {
    scrollContent.style.animationPlayState = 'running';
    scrollContentReverse.style.animationPlayState = 'running';
  }
});

onUnmounted(() => {
  if (animationId) {
    scrollContent.value.style.animationPlayState = 'paused';
    scrollContentReverse.value.style.animationPlayState = 'paused';

  }
});
</script>
 
<style scoped>
h2 {
    text-align: left;
    color: #e91e63;
    font-size: 45px;
    text-align: center;
    margin: 140px 30px 160px;
}
.logo-scroll-container {
  overflow: hidden;
  width: 100%;
}
 
.logo-scroll {
  display: flex;
  width: 200%;
  animation: scroll 25s linear infinite;
}
 
.logo-scroll.reverse {
  animation-direction: reverse;
  margin-top: 50px; 
}
 
.logo-item {
  flex: 0 0 auto;
  margin-right: 50px;
  width: 170px;
  height: auto;
}
 
.logo-item img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.logo_cp {
  width: 220px;
}
 
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
@media screen and (max-width: 750px ) {
  h2 {
    margin: 100px 30px 20px;
  }
  .logo-scroll {
      animation: scroll 5s linear infinite;
  }
  .logo-scroll.reverse {
    margin-top: 0;
  }
  .logo-item {
    width: 230px;
  }
}

</style>